import type { Review } from "@/data/reviewTypes";

export const BOSTON_REVIEWS: Review[] = [
  { name: "Miguel K.", initials: "MK", rating: 5, date: "1 week ago", text: "BOS curbside pickup for a 14-person crew to Fenway Park. Sprinter was spotless, driver knew every Boston shortcut. Booking again." },
  { name: "Sara R.", initials: "SR", rating: 5, date: "3 weeks ago", text: "Bachelorette weekend around Back Bay. Easy delivery to our hotel, captain's chairs, cold AC even in Boston heat. Perfect." },
  { name: "Devon T.", initials: "DT", rating: 5, date: "1 month ago", text: "Booked the 15-passenger for Boston game day. On-time, full tank, no surprise charges. Best van rental in Greater Boston." },
];
